import {
  FormControlLabel, FormGroup, Grid, Radio
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { useStores } from 'hooks';
import { buildDefaultAndTraineeAnswers } from '../../QuizHelper';
import { CheckMark } from '../_commons';

const RadioGroupQuestion = observer(({ currentQuestionData, withCorrection, isReadOnlyQuestion }) => {
  const { isCorrect, isAnswered } = currentQuestionData;

  const { examinationStore } = useStores();

  const { currentPage } = examinationStore;

  const [defaultAnswers, setDefaultAnswers] = useState([]);

  const buildAnswers = useCallback(() => {
    setDefaultAnswers(buildDefaultAndTraineeAnswers(currentQuestionData));
  }, [currentQuestionData]);

  useEffect(() => {
    buildAnswers();
  }, [buildAnswers]);

  const handleRadioChange = useCallback((event, index) => {
    const { checked } = event.target;

    const newDefaultAnswers = defaultAnswers.map((ans, indx) => ({
      ...ans,
      isItemAnswered: index === indx ? checked : false
    }));
    const trainAnswers = newDefaultAnswers.filter(defaultAnswer => defaultAnswer.isItemAnswered).map(ans => ans.answerText);

    setDefaultAnswers(newDefaultAnswers);

    examinationStore.setTraineeAnswers(currentPage, currentQuestionData, trainAnswers[0]);
  }, [currentPage, currentQuestionData, defaultAnswers, examinationStore]);

  return (
    <>
      {defaultAnswers && defaultAnswers.map((defaultAnswer, index) => (
        <Grid alignItems="center" className="pdf-export__content__question--print-inline" container direction="row" key={shortid.generate()}>
          {withCorrection && isReadOnlyQuestion && !isCorrect && (
            <CheckMark
              isDefaultAnswerCorrect={defaultAnswer.isDefaultAnswerCorrect}
              isQuestionAnswered={isAnswered}
            />
          )}
          <Grid item>
            <FormGroup>
              <FormControlLabel
                className="pdf-export__content__question--print-inline"
                control={(
                  <Radio
                    checked={defaultAnswer.isItemAnswered}
                    color="primary"
                    disabled={isReadOnlyQuestion}
                    name={`radio-answer-${index}-${currentQuestionData?.id}`}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={event => handleRadioChange(event, index)}
                  />
                )}
                label={defaultAnswer.answerText}
              />
            </FormGroup>
          </Grid>
        </Grid>
      ))}
    </>
  );
});

export default RadioGroupQuestion;

RadioGroupQuestion.propTypes = {
  currentQuestionData: PropTypes.shape({}),
  withCorrection: PropTypes.bool.isRequired,
  isReadOnlyQuestion: PropTypes.bool.isRequired
};

RadioGroupQuestion.defaultProps = {
  currentQuestionData: {}
};
